<template>
  <!-- eslint-disable vue-a11y/label-has-for, vue-a11y/form-has-label -->
  <div class="Field-cont DatePicker">
    <label v-if="label || icon" :for="inputId">
      {{ label }}
      <span v-if="required" class="required">
        *
      </span>
      <Icon :name="icon" />
    </label>
    <div class="Field">
      <Datetime
        :id="inputId"
        :auto="true"
        :format="isTime ? 'HH:mm' : 'yyyy MMM dd'"
        :minuteStep="10"
        :type="isTime ? 'time' : 'date'"
        :use12Hour="false"
        :value="dateString"
        :weekStart="7"
        @input="setDate" />
    </div>
  </div>
</template>

<script>
import 'vue-datetime/dist/vue-datetime.css'
import { Datetime } from 'vue-datetime'
import { Settings } from 'luxon'
import { defaultLocale } from '../../config'
import { randomString } from 'views/utils'

Settings.defaultLocale = defaultLocale

export default {
  components: { Datetime },
  props: {
    icon: String,
    isTime: Boolean,
    label: String,
    value: Date,
    required: Boolean,
  },
  data() {
    return {
      inputId: randomString(),
    }
  },
  computed: {
    dateString() {
      if (!this.value) return ''

      return this.value.toISOString()
    },
  },
  methods: {
    setDate(dateString) {
      const emittedDate = dateString
        ? new Date(dateString)
        : null

      this.$emit('update:value', emittedDate)
    },
  },
}
</script>

<style lang="scss">
.Field-cont.DatePicker {
  > label {
    @include maxMd {
      top: 0.5rem;
    }
  }

  .vdatetime-input {
    cursor: pointer;
    display: block;
    width: 100%;
  }
}
</style>
